import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { skipDefaultErrorMessagingToken } from '../misc-services/resources/url-request.service';
import { HttpErrorHandler } from './http-error-handler';

/**
 * Interceptor provided to the Angular framework to be called for all HTTP
 * errors.
 */
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private httpErrorHandler = inject(HttpErrorHandler);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let result$ = next.handle(req);
    if (!req.context.get(skipDefaultErrorMessagingToken)) {
      result$ = result$.pipe(
        tap({
          error: (error: unknown) => this.httpErrorHandler.handleError(error),
        }),
      );
    }
    return result$;
  }
}
